// Use this axios instance to make calls to the api
import axios from 'axios';

import { LOCAL_STORAGE_SESSION_KEY } from '../context/AuthContext';

const API_URL = import.meta.env.VITE_API_URL;

export const createAxios = (baseURL = API_URL) => {
  const axiosInstance = axios.create({
    baseURL,
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  });

  axiosInstance.interceptors.response.use(null, (err) => {
    if (
      !err.config.url.startsWith('/auth') &&
      err.response.status === 401 &&
      err.response.data.name === 'Unauthorized'
    ) {
      localStorage.removeItem(LOCAL_STORAGE_SESSION_KEY);
      window.location.href = '/login';
    }

    return Promise.reject(err);
  });

  return axiosInstance;
};
